import React, { useState, useEffect } from 'react';
import PageTitle from '../../module/pageTitle';
import LabelInput from '../../Component/labelInput';
import DropDown from '../../Component/dropdown';
import Submitbtn from '../../Component/submitbtn';
import PaginationRounded from '../../Component/pagination';
import AdminTable from '../../Component/adminTable';
import PaginationView from '../../Component/paginationView';
import InputField from '../../Component/inputField';
import DatePicker from '../../Component/datePicker';
import moment from "moment";
import ImagePickerAndViewer from '../../Component/imagePickerAndViewer';
import AddMoreBtn from '../../Component/addMoreBtn';
import { getEmployeeList, getCompanyList, getDepartmentList, getSubDepartmentList, getDesignationList, getManagerList, addEmployee, uploadEmployeeFile } from './superAdminSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { showSnackbar, hideSnackbar } from '../../store/slices/snackbarSlice';

const ManageEmployee = () => {
    const initialEducation = [
        {
            resultFile: "",
            selectedResultFile: "",
            institutionName: "",
            level: "",
        },
    ];
    const initialAccount = [
        {
            bankName: "",
            accountNumber: "",
            ifscCode: "",
            branch: "",
            isDefault: false,
        },
    ];
    const initialOther = [
        {
            exitDate: "",
            panelRole: "",
        },
    ];
    const initialKyc = [
        { name: "", number: "", file: "", selectedFile: "" },
        { name: "", number: "", file: "", selectedFile: "" },
    ];
    // const initialManagerList = [
    //     { name: 'Dharamveer Sharma', _id: "1" },
    // ];

    const dispatch = useDispatch<AppDispatch>();
    const [employeeList, setEmployeeList] = useState<any>([])
    const [companyList, setCompanyList] = useState<any>([]);
    const [companyName, setCompanyName] = useState<any>();
    const [departmentList, setDepartmentList] = useState<any>([]);
    const [departmentName, setDepartmentName] = useState<any>();
    const [subDepartmentList, setSubDepartmentList] = useState<any>([]);
    const [subDepartmentName, setSubDepartmentName] = useState<any>();
    const [empID, setEmpID] = useState<any>();
    const [firstName, setFirstName] = useState<any>();
    const [lastName, setLastName] = useState<any>();
    const [mobileNumber, setMobileNumber] = useState<any>();
    const [userName, setUserName] = useState<any>();
    const [password, setPassword] = useState<any>();
    const [email, setEmail] = useState<any>();
    const [gender, setGender] = useState<any>();
    const [empCompanyList, setEmpCompanyList] = useState<any>([]);
    const [empCompanyName, setEmpCompanyName] = useState<any>([]);
    const [empDepartmentList, setEmpDepartmentList] = useState<any>([]);
    const [empDepartmentName, setEmpDepartmentName] = useState<any>();
    const [empSubDepartmentList, setEmpSubDepartmentList] = useState<any>([]);
    const [empSubDepartmentName, setEmpSubDepartmentName] = useState<any>();
    const [joiningDate, setJoiningDate] = useState<any>();
    const [empType, setEmpType] = useState<any>();
    const [empSalary, setEmpSalary] = useState<any>();
    const [CTC, setCTC] = useState<any>();
    const [empDesignationList, setEmpDesignationList] = useState<any>([]);
    const [empDesignation, setEmpDesignation] = useState<any>();
    const [empReportingManagerList, setEmpReportingManagerList] = useState<any>([]);
    const [empReportingManagerName, setEmpReportingManagerName] = useState<any>();
    // const [empMappingList, setEmpMappingList] = useState<any>([]);
    const [empMappingName, setEmpMappingName] = useState<any>();
    const [offerLetter, setOfferLetter] = useState<any>();
    const [joiningLetter, setJoiningLetter] = useState<any>();
    // const [hrList, setHrList] = useState<any>([]);
    const [hrName, setHrName] = useState<any>();
    const [educationalDetails, setEducationalDetils] = useState<any>(initialEducation);
    const [kycDetails, setKycDetails] = useState<any>(initialKyc)
    const [bankDetails, setBankDetails] = useState<any>(initialAccount);
    const [otherDetails, setOtherDetails] = useState<any>(initialOther);
    const [pfNumber, setPfNumber] = useState<any>();
    const [uanNumber, setUanNumber] = useState<any>();
    const [isAddEmployee, setIsAddEmployee] = useState<any>(false);
    const [isEditEmployee, setIsEditEmployee] = useState<any>(false);
    useEffect(() => {
        const payload = {
            status: "active",
            skip: 0,
            limit: 10
        }
        dispatch(getEmployeeList({
            params: payload,
            callback: (res: any) => {
                console.log("res", res);
                setEmployeeList(res);
            },
            errorCallback: () => { }
        }));
        dispatch(
            getCompanyList({
                callback: (res: any) => {
                    setCompanyList(res?.data);
                },
                errorCallback: () => { },
            })
        );
        dispatch(
            getDepartmentList({
                callback: (res: any) => {
                    setDepartmentList(res?.data);
                },
                errorCallback: () => { },
            })
        );
        dispatch(
            getDesignationList({
                callback: (res: any) => {
                    setEmpDesignationList(res?.data);
                },
                errorCallback: () => { },
            })
        );
    }, [dispatch]);

    const [state, setState] = useState({
        companyName: '',
        departmentName: '',
        subDepartmentName: '',
        isEditEmployee: false,
        isAddEmployee: false,
        employeeId: '',
        employeeType: "",
        ctc: "",
        company: "",
        lastName: "",
        firstName: "",
        currentSalary: "",
        mapping: "",
        hrName: "",
        reportingManager: "",
        designation: "",
        subDepartment: "",
        department: "",
        userName: '',
        email: "",
        password: "",
        gender: "",
        mob: '',
        joiningDate: '',
        educationalArr: initialEducation,
        exitDate: '',
        panelRole: '',
        branch: '',
        bankData: initialAccount,
        kycDataArr: initialKyc,
        isCalculate: false,
        basicSalaryData: {
            basic: "",
            HRA: "",
            specialAllowance: "",
            conveyance: "",
            PT: "",
            IT: "",
            totalDeduction: "",
            gross: "",
            netSalary: "",
            otherDeduction: "",
            PF: "",
            TDS: "",
            GST: "",
        },
        gstOpt: "",
        otherDeduction: "",
        providentFund: "",
        pfAccount: '',
        uanNumber: '',
        professionalTax: "",
        incomeTaxOpt: '',
        incomeTaxAmt: '',
        otherDeductionAmt: '',
        appraisalMail: "",
        offerLetter: '',
        joiningLetter: '',
    });

    const genderData = [
        { _id: 1, name: "Male", },
        { _id: 2, name: "Female", },
    ];
    const empTypeData = [
        {
            id: 1,
            name: "Proffessional",
        },
        {
            id: 2,
            name: "Employee",
        },
    ];

   
    const mappingList = [
        {
            id: 1,
            name: "LIFE SCIENCE"
        },
        {
            id: 2,
            name: "CHEMICAL SCIENCE"
        },
        {
            id: 3,
            name: "PHYSICAL SCIENCE"
        },
        {
            id: 4,
            name: "MATHEMATICAL SCIENCE"
        },
        {
            id: 5,
            name: "UGC NET"
        },
        {
            id: 6,
            name: "COMMON"
        }
    ];
    const hrList = [
        {
            id: 1,
            name: "PRAGATI WAGARE",
        },
        {
            id: 2,
            name: "SNEHAL KSHIGSAGAR",
        },
        {
            id: 3,
            name: "DIPSHIKA THUL",
        },
        {
            id: 4,
            name: "SAPANA BHOLANKAR",
        },

        {
            id: 5,
            name: "VASUDHA RAJPUT",
        },
        {
            id: 6,
            name: "GURUPREM RAJPAL",
        },
        {
            id: 7,
            name: "SHRUTI SINGH",
        },
        {
            id: 8,
            name: "PRAVEEN DWIVEDI",
        }
    ];
    const educationalData = [
        {
            id: 1,
            name: "10th",
        },
        {
            id: 2,
            name: "12th",
        },
        {
            id: 3,
            name: "Graduation",
        },
        {
            id: 4,
            name: "Post Graduation",
        },
        {
            id: 5,
            name: "PHD",
        },
        {
            id: 6,
            name: "Diploma",
        },
    ];
    const panelRoleList = [
        {
            id: 1,
            name: "ADMIN"
        },
        {
            id: 2,
            name: "CATEGORY"
        },
        {
            id: 3,
            name: "CONFIG"
        },
        {
            id: 4,
            name: "COUNSELLOR"
        },
        {
            id: 5,
            name: "CXO"
        },
        {
            id: 6,
            name: "DATAENTRY"
        },
        {
            id: 7,
            name: "FINANCE"
        },
        {
            id: 8,
            name: "HOD"
        },
        {
            id: 9,
            name: "INFRA"
        },
        {
            id: 10,
            name: "PAIDAD"
        },
    ];

    const onChangeContent = (val: any, key: string) => {
        if (key === 'company') setCompanyName(val);
        else if (key === 'department') {
            setDepartmentName(val);
            dispatch(getSubDepartmentList({
                id: val?._id,
                callback: (res: any) => {
                    setSubDepartmentList(res?.data);
                },
                errorCallback: () => { }
            }));
        }
        else if (key === 'subDepartment') setSubDepartmentName(val);
    }
    const onChangeEmployeeDetails = (val: any, key: string) => {
        if (key === 'empID') setEmpID(val);
        else if (key === 'firstName') setFirstName(val);
        else if (key === 'lastName') setLastName(val);
        else if (key === 'mobileNumber') setMobileNumber(val);
        else if (key === 'userName') setUserName(val);
        else if (key === 'password') setPassword(val);
        else if (key === 'email') setEmail(val);
        else if (key === 'gender') setGender(val);
    }
    const onChangeEmploymentDetails = (val: any, key: string) => {
        if (key === 'empComany') setEmpCompanyName(val);
        else if (key === 'joiningDate') setJoiningDate(val);
        else if (key === 'empType') setEmpType(val);
        else if (key === 'currentSalary') setEmpSalary(val);
        else if (key === 'ctc') setCTC(val);
        else if (key === 'department') {
            setEmpDepartmentName(val);
            dispatch(getSubDepartmentList({
                id: val?._id,
                callback: (res: any) => {
                    setEmpSubDepartmentList(res?.data);
                },
                errorCallback: () => { }
            }));
        }
        else if (key === 'subDept') setEmpSubDepartmentName(val);
        else if (key === 'designation') {
            setEmpDesignation(val);
            dispatch(
                getManagerList({
                    params: { designation: val?._id },
                    callback: (res: any) => {
                        console.log("res", res);
                        setEmpReportingManagerList(res);
                    },
                    errorCallback: () => { },
                })
            );
        }
        else if (key === 'reportingManager') setEmpReportingManagerName(val);
        else if (key === 'mapping') setEmpMappingName(val);
        else if (key === 'hr') setHrName(val);
        else if (key === 'reportingManager') setEmpReportingManagerName(val);
    };

    const handleChangeJoiningDetails = (e: any, key: string) => {
        e.preventDefault();
        if (!e.target.files?.[0]) return;
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            dispatch(uploadEmployeeFile({
                params: file,
                callback: (res: any) => {
                    if (res?.status === "success") {
                        if (key === "offerLetter") setOfferLetter(res?.data?.filePath);
                        else if (key === "joining") setJoiningLetter(res?.data?.filePath);
                        dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                        }, 5000);
                    }
                },
                errorCallback: () => {
                    dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
            }));
        };

        reader.readAsDataURL(file);
    };
    const onChangeEducationDetail = (index: number, val: any, key: string) => {
        if (key === "document") {
            setEducationalDetils((prev: any) =>
                prev.map((item: any, i: number) =>
                    i === index ? { ...item, level: val } : item
                )
            );
        } else if (key === "institutionName") {
            setEducationalDetils((prev: any) =>
                prev.map((item: any, i: number) =>
                    i === index ? { ...item, institutionName: val } : item
                )
            );
        }
    };
    const uploadEducationCertificate = (e: any, index: number) => {
        e.preventDefault();
        if (!e.target.files?.[0]) return;
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            dispatch(uploadEmployeeFile({
                params: file,
                callback: (res: any) => {
                    if (res?.status === "success") {
                        setEducationalDetils((prev: any) =>
                            prev.map((item: any, i: any) => i === index ?
                                { ...item, resultFile: res?.data?.filePath, selectedResultFile: reader.result }
                                : item
                            )
                        );
                        dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                        }, 5000);
                    }
                },
                errorCallback: () => {
                    dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
            }));
        };

        reader.readAsDataURL(file);
    };
    const onPressAdd = () => {
        setEducationalDetils([...educationalDetails, initialEducation]);
    };
    const handleClose = (index: any) => {
        const newArray = [...educationalDetails];
        if (index > -1) {
            newArray.splice(index, 1);
        }
        setEducationalDetils(newArray);
    };
    const onChangeKYC = (val: any, key: string, index: any) => {
        if (key === "name") {
            setKycDetails((prev: any) =>
                prev.map((item: any, i: number) =>
                    i === index ? { ...item, name: val } : item
                )
            );
        } else if (key === "number") {
            setKycDetails((prev: any) =>
                prev.map((item: any, i: number) =>
                    i === index ? { ...item, number: val } : item
                )
            );
        }
    };
    const onUploadKycDoc = (e: any, index: number) => {
        e.preventDefault();
        if (!e.target.files?.[0]) return;
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            dispatch(uploadEmployeeFile({
                params: file,
                callback: (res: any) => {
                    if (res) {
                        setKycDetails((prev: any) =>
                            prev.map((item: any, i: any) => i === index ?
                                { ...item, file: res?.data?.filePath, selectedFile: reader.result }
                                : item
                            )
                        );
                    }
                },
                errorCallback: () => { },
            }));
        };

        reader.readAsDataURL(file);
    };

    const onChangeBankDetails = (val: any, key: string, index: number) => {
        setBankDetails((prev: any) =>
            prev.map((item: any, i: number) =>
                i === index ? { ...item, [key]: val } : item
            )
        );
    };
    const onPressAddBank = () => {
        setBankDetails([...bankDetails, initialAccount]);
    };
    const handleCloseBank = (index: any) => {
        const newArray = [...bankDetails];
        if (index > -1) {
            newArray.splice(index, 1);
        }
        setBankDetails(newArray);
    };
    const onChangeOtherDetails = (index: number, val: any, key: string) => {
        if (key === "exitDate") {
            setOtherDetails((prev: any) => {
                prev.map((item: any, i: number) => i === index ? { ...item, exitDate: val } : item)
            })
        } else if (key === "panelRole") {
            setOtherDetails((prev: any) => {
                prev.map((item: any, i: number) => i === index ? { ...item, panelRole: val } : item)
            })
        }
    };
    const onPressAddOther = () => {
        setOtherDetails([...otherDetails, initialOther]);
    };
    const handleCloseOther = (index: any) => {
        const newArray = [...otherDetails];
        if (index > -1) {
            newArray.splice(index, 1);
        }
        setOtherDetails(newArray);
    };
    const updateState = (key: any) => {
        setState((prevState: any) => ({
            ...prevState,
            ...key,
        }));

    };
    const handleAddEmployee = () => {
        setIsAddEmployee(true);
        dispatch(getCompanyList({
            callback: (res: any) => {
                setEmpCompanyList(res?.data);
            },
            errorCallback: () => { }
        }));
        dispatch(getDepartmentList({
            callback: (res: any) => {
                setEmpDepartmentList(res?.data);
            },
            errorCallback: () => { }
        }));
    };

    const handleEdit = (value: any) => {
        console.log("value", value);
        setIsEditEmployee(true)
        setIsAddEmployee(false);
        setEmpID(value?.employeeId);
        setFirstName(value?.firstName);
        setLastName(value?.lastName);
        setMobileNumber(value?.mobileNo);
        setUserName(value?.userName);
        setPassword(value?.password);
        setEmail(value?.email);
        setGender(value?.gender);
        setCompanyName(value?.company);
        setEmpSalary(value?.monthlySalary);
        setCTC(value?.salary);
        setDepartmentName(value?.department);
        setSubDepartmentName(value?.subDepartment);
    }
    const handleDelete = (value: any) => {
        updateState({ isAddEmployee: false, isEditEmployee: true });
    }

    const onChangeText = (val: any, key: string) => {
        if (key === "userName") updateState({ userName: val });
        else if (key === "password") updateState({ password: val });
        else if (key === "email") updateState({ email: val });
        else if (key === "ctc") updateState({ ctc: val });
        else if (key === "currentSalary") updateState({ currentSalary: val });

    };

    const cancelEdit = () => {
        if (isAddEmployee === true) {
            setIsAddEmployee(false);
        } else if (isEditEmployee === true) {
            setIsEditEmployee(false);
        }
    }
    const submitEmployee = (e: any) => {
        e.preventDefault();
        const education = educationalDetails.map((item: any) => {
            return {
                resultFile: item?.resultFile,
                level: item?.level?.name,
                institutionName: item?.institutionName
            };
        });
       
        const postData = {
            employeeId: empID,
            firstName: firstName,
            lastName: lastName,
            mobileNo: mobileNumber,
            username: userName,
            password: password,
            email: email,
            gender: gender?.name,
            status: 1,
            companyId: empCompanyName?._id,
            doj: joiningDate,
            isProfessional: empType?._id === 1 ? true : false,
            salary: CTC,
            monthlySalary: empSalary,
            departmentId: empDepartmentName?._id,
            subDepartmentId: empSubDepartmentName?._id,
            designation: empDesignation?._id,
            managerId: empReportingManagerName?._id,
            transactionData: {
                basic: "",
                HRA: "",
                specialAllowance: "",
                conveyance: "",
                PT: "",
                PF: "",
                IT: "",
                totalDeduction: "",
                gross: "",
                netSalary: "",
            },
            joiningDocuments: {
                joiningLetter: joiningLetter,
                offerLetter: offerLetter,
            },
            educationDetails: education,
            kycDetails: kycDetails,
            bankDetails: bankDetails,
            gst: false,
            isPF: true,
            refferdBy: hrName?.name,
            PF_ACCOUNT_NO: pfNumber,
            UAN_NO: uanNumber,
        };
        // if (empMappingName === "") delete postData.mappingId;
        // if (pfNumber === "") delete postData.PF_ACCOUNT_NO;
        // if (uanNumber === "") delete postData.UAN_NO;
        // if (panelRole === "") delete postData.role;
        // if (hrName === "") delete postData.refferdBy;
        dispatch(
            addEmployee({
                params: postData,
                callback: (res: any) => {
                    dispatch(showSnackbar({ message: "", type: res?.data?.status }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
                errorCallback: (err: any) => {
                    dispatch(showSnackbar({ message: err?.data?.msg, type: err?.data?.status }))
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                },
            })
        );
    };

    const renderSearch = () => {
        return (
            <form>
                <div className="row justify-content-evenly align-items-center">
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Company"} />
                        <DropDown
                            labelName={"Select Company"}
                            setInputText={(value: any) => onChangeContent(value, "company")}
                            options={companyList}
                            value={companyName}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Department"} />
                        <DropDown
                            labelName={"Select Department"}
                            setInputText={(value: any) => onChangeContent(value, "department")}
                            options={departmentList}
                            value={departmentName}
                        />
                    </div>
                    <div className="col-md-3 mb-3">
                        <LabelInput labelName={"Sub Department"} />
                        <DropDown
                            labelName={"Select Sub Department"}
                            setInputText={(value: any) => onChangeContent(value, "subDepartment")}
                            options={subDepartmentList}
                            value={subDepartmentName}
                        />
                    </div>
                    <div className='col-md-2'>
                        <LabelInput labelName={""} />
                        <Submitbtn name={"Search"} disabled={false} />
                    </div>
                </div>
            </form >
        );
    };
    const actionButtons = () => {
        return (
            <div className='d-xl-flex justify-content-between align-items-center d-lg-block d-sm-block d-block'>
                <PaginationView tabs={["Active", "Exit", "Deleted"]} handleClick={handleAddEmployee} totalCount={''} handleSubmit={() => ('')} />
                <PaginationRounded />
            </div>

        )
    }
    const renderTable = () => {
        return (
            <AdminTable
                tableData={employeeList ? employeeList : []}
                pagename={"employeeList"}
                tableHead={["S.N", "Name", "Employee ID", "Mobile No", "Company", "Reporting Manager", "Department", "Designation", "Panel Role", "Action"]}
                handleEdit={(value: any) => handleEdit(value)}
                handleDelete={(value: any) => handleDelete(value)}
                edit={true} />
        )
    }

    const renderEmployeeDetail = () => {
        const { employeeId, isEditEmployee } = state;
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    EMPLOYEE PERSONAL DETAILS
                </div>
                <div className='bxshadow p-3 borderRadius mb-4'>
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Employee ID"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Employee ID"}
                                value={empID}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "empID")}
                            // isRequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"First Name"} />
                            <InputField
                                key={"ex2"}
                                placeholder={" First Name"}
                                value={firstName}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "firstName")}
                            // maxLength={100}
                            // minLength={100}
                            // isRequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Last Name"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Last Name"}
                                value={lastName}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "lastName")}
                            // maxLength={100}
                            // minLength={100}
                            // isRequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Mobile no"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Mobile no."}
                                value={mobileNumber}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "mobileNumber")}
                                maxLength={10}
                                minLength={10}
                            // isRequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"User Name"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"User Name"}
                                value={userName}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "userName")}
                                // maxLength={100}
                                // minLength={100}
                                // isRequired={true}
                                disabled={isEditEmployee}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Password"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Password"}
                                value={password}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "password")}
                                // isRequired={true}
                                disabled={isEditEmployee}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Email"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Email"}
                                value={email}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "email")}
                            // isRequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Select Gender"} />
                            <DropDown
                                labelName={"Select Gender"}
                                setInputText={(value: any) => onChangeEmployeeDetails(value, "gender")}
                                options={genderData}
                                value={gender}
                            />
                        </div>
                    </div >
                </div>
            </>
        );
    };
    const renderEmploymentDetail = () => {
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    EMPLOYMENT DETAILS
                </div>
                <div className='bxshadow p-3 borderRadius mb-4'>
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Select Company"} />
                            <DropDown
                                labelName="Select Company"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "empComany")}
                                value={empCompanyName}
                                options={empCompanyList}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Date of Joining"} />
                            <DatePicker
                                value={joiningDate}
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "joiningDate")}
                                // Isrequired={true}
                                defaultValue={joiningDate}
                                maxdate={moment.utc(new Date()).format("YYYY-MM-DD")}
                                mindate={""}
                                disabled={false}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Employee Type"} />
                            <DropDown
                                labelName="Employee Type"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "empType")}
                                options={empTypeData}
                                value={empType}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Current Salary"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Current Salary"}
                                value={empSalary}
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "currentSalary")}
                            // maxLength={100}
                            // minLength={100}
                            // isRequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"CTC"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"CTC"}
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "ctc")}
                                value={CTC}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Department"} />
                            <DropDown
                                labelName="Department"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "department")}
                                value={empDepartmentName}
                                options={empDepartmentList}
                            // value={departmentName}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Sub Department"} />
                            <DropDown
                                labelName="Sub Department"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "subDept")}
                                value={empSubDepartmentName}
                                options={empSubDepartmentList}
                            // Isrequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Designation"} />
                            <DropDown
                                labelName="Designation"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "designation")}
                                value={empDesignation}
                                options={empDesignationList}
                            // Isrequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Reporting Manager"} />
                            <DropDown
                                labelName="Reporting Manager"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "reportingManager")}
                                value={empReportingManagerName}
                                options={empReportingManagerList}
                            // Isrequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"Mapping"} />
                            <DropDown
                                labelName="Mapping"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "mapping")}
                                value={empMappingName}
                                options={mappingList}
                            // Isrequired={true}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <LabelInput labelName={"HR"} />
                            <DropDown
                                labelName="HR"
                                setInputText={(value: any) => onChangeEmploymentDetails(value, "hr")}
                                options={hrList}
                                value={hrName}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };
    const renderFixedDeduction = () => {
        // const { isCalculate, employeeType, basicSalaryData } = state;
        return (
            <>
                {/* {employeeType === "" ? null : ( */}
                <>
                    <div className="colorBlack font18 fw-bold mb-3">
                        FIXED DEDUCTION
                    </div>
                    <div className='bxshadow p-3 borderRadius mb-4'>
                        {/* {employeeType?._id === 1 ? ( */}
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"GST"} />
                                <DropDown
                                    labelName="Select Option"
                                    setInputText={(value: any) => updateState({ gstOpt: value })}
                                    options={''}
                                    value={state?.gstOpt}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Other Deduction"} />
                                <DropDown
                                    labelName="Select Option"
                                    setInputText={(value: any) =>
                                        updateState({ otherDeduction: value })
                                    }
                                    options={""}
                                    value={state?.otherDeduction}
                                />
                            </div>
                            {/* {state?.otherDeduction.name === "Yes" && ( */}
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Add Other Deduction"} />
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Add Other Deduction"}
                                    setInputText={(value: any) => onChangeText(value, "otherDiduction")}
                                    value={state?.otherDeduction}
                                />
                            </div>
                            {/* )} */}
                        </div>
                        {/* ) : employeeType?._id === 2 ? ( */}
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Provident Fund"} />
                                <DropDown
                                    labelName="Provident Fund"
                                    setInputText={(value: any) => updateState({ providentFund: value })}
                                    options={""}
                                    value={state?.providentFund}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"PF Account"} />
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter PF Account"}
                                    value={state?.pfAccount}
                                    setInputText={(value: any) =>
                                        updateState({ pfAccount: value })
                                    }
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"UAN Number"} />
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter UAN Number"}
                                    value={state?.uanNumber}
                                    setInputText={(value: any) => updateState({ uanNumber: value })}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Professional tax"} />
                                <DropDown
                                    labelName="Professional tax"
                                    setInputText={(value: any) => updateState({ professionalTax: value })}
                                    options={""}
                                    value={state?.professionalTax}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Income Tax"} />
                                <DropDown
                                    labelName="Select Option"
                                    setInputText={(value: any) => updateState({ incomeTaxOpt: value })}
                                    options={""}
                                    value={state?.incomeTaxOpt}
                                />
                            </div>
                            {/* {state?.incomeTaxOpt.name === "Yes" && ( */}
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Income Tax Amount"} />
                                <InputField
                                    placeholder={"Enter Income Tax Amount"}
                                    value={state?.incomeTaxAmt}
                                    setInputText={(value: any) => updateState({ incomeTaxAmt: value })
                                    }
                                />
                            </div>
                            {/* )} */}
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Other Deduction"} />
                                <DropDown
                                    labelName="Other Deduction"
                                    setInputText={(value: any) => updateState({ otherDeduction: value })
                                    }
                                    options={""}
                                    value={state?.otherDeduction}
                                />
                            </div>
                            {/* {state?.otherDeduction.name === "Yes" && ( */}
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Deduct Amount"} />
                                <InputField
                                    key={"ex2"}
                                    placeholder={"Enter Other Deduct Amount"}
                                    value={state?.otherDeductionAmt}
                                    setInputText={(value: any) => updateState({ otherDeductionAmt: value })
                                    }
                                />
                            </div>
                            {/* )} */}
                        </div>
                        {/* ) : null} */}
                    </div>
                </>
                {/* )} */}
            </>
        )
    };
    const renderJoiningDocs = () => {
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    JOINING DETAILS
                </div>
                <div className='bxshadow p-3 borderRadius mb-4'>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <LabelInput labelName={"Offer Letter"} />
                            <ImagePickerAndViewer
                                value={offerLetter}
                                handleChange={(e: any) => handleChangeJoiningDetails(e, "offerLetter")}
                                htmlFor={"photo-upload-offerLette"}
                                doctype={"pdf/image"} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <LabelInput labelName={"Joining Letter"} />
                            <ImagePickerAndViewer
                                value={joiningLetter}
                                handleChange={(e: any) => handleChangeJoiningDetails(e, "joining")}
                                htmlFor={"photo-upload-joining"}
                                doctype={"pdf/image"}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };
    const renderEducation = () => {
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    EDUCATIONAL DETAILS
                </div>
                {educationalDetails?.map((item: any, index: number) => {
                    const { level, institutionName, resultFile, selectedResultFile } = item;
                    return (
                        <div className='col-md-6 d-flex'>
                            <div className='bxshadow p-3 borderRadius mb-4 w-100'>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <LabelInput labelName={"Document"} />
                                        <DropDown
                                            labelName="Select Document"
                                            setInputText={(value: any) =>
                                                onChangeEducationDetail(index, value, "document")
                                            }
                                            options={educationalData}
                                            value={level}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <LabelInput labelName={"College Name"} />
                                        <InputField
                                            key={"ex2"}
                                            placeholder={"College Name"}
                                            value={institutionName}
                                            setInputText={(value: any) =>
                                                onChangeEducationDetail(index, value, "institutionName")
                                            }
                                        // isRequired={true}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <LabelInput labelName={"Upload Certificate"} />
                                        <ImagePickerAndViewer
                                            value={selectedResultFile}
                                            handleChange={(e: any) => uploadEducationCertificate(e, index)}
                                            htmlFor={`photo-upload-${index + 2}`}
                                            doctype={"pdf/image"}
                                        />
                                    </div>
                                </div>
                                {index === educationalDetails.length - 1 && (
                                    <div className='text-end'>
                                        <AddMoreBtn handleClick={onPressAdd} />
                                    </div>
                                )}
                            </div>
                            {educationalDetails?.length !== 1 ?
                                <DeleteForeverIcon className='text-danger cursor' onClick={() => handleClose(index)} />
                                : ""}

                        </div>
                    )
                })}
            </>
        );
    };
    const renderKyc = () => {
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    KYC DETAILS
                </div>
                <div className='bxshadow p-3 borderRadius mb-4'>
                    <div className="row">
                        {kycDetails?.map((item: any, index: number) => {
                            const { name, number, file, selectedFile } = item;
                            return (
                                <>
                                    <div className="col-md-4 mb-3">
                                        <LabelInput labelName={index === 0 ? "Aadhar Name" : "PAN Name"} />
                                        <InputField
                                            placeholder={index === 0 ? "Aadhar Name" : "PAN Name"}
                                            setInputText={(value: any) => {
                                                if (index === 0) {
                                                    onChangeKYC(value, "name", 0);
                                                } else {
                                                    onChangeKYC(value, "name", 1);
                                                }
                                            }}
                                            value={name}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <LabelInput labelName={index === 0 ? "Aadhar Number" : "PAN Number"} />
                                        <InputField
                                            key={"ex2"}
                                            placeholder={index === 0 ? "Aadhar Number" : "PAN Number"}
                                            setInputText={(value: any) => {
                                                if (index === 0) {
                                                    onChangeKYC(value, "number", 0);
                                                } else {
                                                    onChangeKYC(value, "number", 1);
                                                }
                                            }
                                            }
                                            value={number}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <LabelInput labelName={index === 0 ? "Upload Adhar" : "Upload PAN Card"} />
                                        <ImagePickerAndViewer
                                            value={file}
                                            handleChange={(e: any) => {
                                                if (index === 0) {
                                                    onUploadKycDoc(e, 0)
                                                } else {
                                                    onUploadKycDoc(e, 1)
                                                }
                                            }}
                                            htmlFor={`${index === 0 ? "upload-adhar" : "upload-pan"}`}
                                            doctype={"pdf/image"}
                                        />
                                    </div>
                                </>
                            )
                        })}
                        {/* <div className="col-md-4 mb-3">
                            <LabelInput labelName={"Aadhar Name"} />
                            <InputField
                                placeholder={"Enter Aadhar Name"}
                                setInputText={(value: any) => onChangeKYC(value, "adharName")}
                                value={adharName}
                            />
                        </div>
                        <div className="col-md-4 mb-3">
                            <LabelInput labelName={"Aadhar Number"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Enter Aadhar Number"}
                                setInputText={(value: any) => onChangeKYC(value, "adharNumber")}
                                value={adharName}
                            />
                        </div>
                        <div className="col-md-4 mb-3">
                            <LabelInput labelName={"Upload Adhar"} />
                            <ImagePickerAndViewer
                                value={adharDoc}
                                handleChange={(e: any) => onUploadAadhar(e)}
                                htmlFor={`photo-upload`}
                                doctype={"pdf/image"}
                            />
                        </div>
                        <div className="col-md-4 mb-3">
                            <LabelInput labelName={"PAN Name"} />
                            <InputField
                                placeholder={"Enter PAN Name"}
                                setInputText={(value: any) => onChangeKYC(value, "PanName")}
                                value={panName}
                            />
                        </div>
                        <div className="col-md-4 mb-3">
                            <LabelInput labelName={"PAN Number"} />
                            <InputField
                                key={"ex2"}
                                placeholder={"Enter PAN Number"}
                                setInputText={(value: any) => onChangeKYC(value, "PanNumber")}
                                value={""}
                            />
                        </div>
                        <div className="col-md-4 mb-3">
                            <LabelInput labelName={"Upload PAN Card"} />
                            <ImagePickerAndViewer
                                value={panDoc}
                                handleChange={(e: any) => onUploadPAN(e)}
                                htmlFor={`photo-upload}`}
                                doctype={"pdf/image"}
                            />
                        </div> */}
                    </div>
                </div>
            </>
        );
    };
    const renderBank = () => {
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    BANK DETAILS
                </div>
                {bankDetails?.map((item: any, index: number) => {
                    const { bankName, accountNumber, ifscCode, branch, isDefault } = item;
                    return (
                        <div className='col-md-6 d-flex'>
                            <div className='bxshadow p-3 borderRadius mb-4'>
                                <div className="row" key={index}>
                                    <div className="col-md-6 mb-3">
                                        <LabelInput labelName={"Account Name"} />
                                        <InputField
                                            key={"ex2"}
                                            placeholder={"Enter Account Name"}
                                            setInputText={(value: any) => onChangeBankDetails(value, "bankName", index)}
                                            value={bankName}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <LabelInput labelName={"Account No"} />
                                        <InputField
                                            key={"ex2"}
                                            placeholder={"Enter Account Number"}
                                            setInputText={(value: any) => onChangeBankDetails(value, "accountNumber", index)}
                                            value={accountNumber}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <LabelInput labelName={"IFSC Code"} />
                                        <InputField
                                            key={"ex2"}
                                            placeholder={"Enter IFSC code"}
                                            setInputText={(value: any) => onChangeBankDetails(value, "ifscCode", index)}
                                            value={ifscCode}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <LabelInput labelName={"Branch Name"} />
                                        <InputField
                                            key={"ex2"}
                                            placeholder={"Enter Branch Name"}
                                            setInputText={(value: any) => onChangeBankDetails(value, "branch", index)}
                                            value={branch}
                                        />
                                    </div>
                                </div>
                                {index === bankDetails.length - 1 && (
                                    <div className='text-end'>
                                        <AddMoreBtn handleClick={onPressAddBank} />
                                    </div>
                                )}
                            </div>
                            {bankDetails?.length !== 1 ?
                                <DeleteForeverIcon className='text-danger cursor' onClick={() => handleCloseBank(index)} />
                                : ""
                            }
                        </div>
                    )
                })}
            </>
        )
    };
    const renderOtherDetails = () => {
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    OTHER DETAILS
                </div>
                {otherDetails?.map((item: any, index: number) => {
                    const { exitDate, panelRole } = item;
                    return (
                        <div className='col-md-6 d-flex'>
                            <div className='bxshadow p-3 borderRadius mb-4 w-100'>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <LabelInput labelName={"Date of Exit"} />
                                        <DatePicker
                                            value={exitDate}
                                            setInputText={(value: any) => onChangeOtherDetails(index, value, "exitDate")}
                                            defaultValue={exitDate}
                                            maxdate={moment.utc(new Date()).format("YYYY-MM-DD")}
                                            mindate={""}
                                            disabled={false}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <LabelInput labelName={"Panel Role"} />
                                        <DropDown
                                            labelName="Panel Role"
                                            setInputText={(value: any) => onChangeOtherDetails(index, value, "panleRole")}
                                            value={panelRole}
                                            options={panelRoleList}
                                        />
                                    </div>
                                </div>
                                {index === otherDetails.length - 1 && (
                                    <div className='text-end'>
                                        <AddMoreBtn handleClick={onPressAddOther} />
                                    </div>
                                )}
                            </div>
                            {otherDetails?.length !== 1 ?
                                <DeleteForeverIcon className='text-danger cursor' onClick={() => handleCloseOther(index)} />
                                : ""
                            }
                        </div>
                    )
                })}
            </>
        )
    };
    const renderAppraisal = () => {
        const { appraisalMail } = state;
        return (
            <>
                <div className="colorBlack font18 fw-bold mb-3">
                    Appraisal Mail
                </div>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <LabelInput labelName={"Appraisal Amount"} />
                        <InputField
                            key={"ex2"}
                            placeholder={"Add Appraisal Amount"}
                            setInputText={(value: any) => updateState({ appraisalMail: value })}
                            value={appraisalMail}
                        />
                    </div>
                    <div className="col-md-2 mb-3">

                    </div>
                </div>
            </>
        );
    };
    const renderAddMode = () => {
        return (
            <>
                <form onSubmit={submitEmployee}
                    className=""
                // onSubmit={state?.isAddEmployee ? handleSubmit : handleUpdate}
                >
                    <div className="">
                        {renderEmployeeDetail()}
                        {renderEmploymentDetail()}
                        <div className='row'>
                            <div className='col-md-6'>
                                {renderJoiningDocs()}
                            </div>
                            <div className='col-md-12'>
                                <div className='row'>
                                    {renderEducation()}
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                {renderKyc()}
                            </div>
                            <div className='col-md-12'>
                                <div className='row'>
                                    {renderBank()}
                                </div>
                            </div>
                            <div className='col-md-12'>
                                <div className='row'>
                                    {renderOtherDetails()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-2 mx-auto'>
                        <Submitbtn name={"Submit"} disabled={!joiningDate} />
                    </div>

                </form>
            </>
        );
    };
    const renderEditMode = () => {
        return (
            <>
                <form
                    className=""
                // onSubmit={state?.isAddEmployee ? handleSubmit : handleUpdate}
                >
                    <div className="">
                        {renderEmployeeDetail()}
                        {renderEmploymentDetail()}
                        {renderFixedDeduction()}
                        <div className='row'>
                            <div className='col-md-6'>
                                {renderJoiningDocs()}
                            </div>
                            <div className='col-md-6'>
                                {renderEducation()}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                {renderKyc()}
                            </div>
                            <div className='col-md-6'>
                                {renderBank()}
                            </div>
                            <div className='col-md-6'>
                                {renderOtherDetails()}
                            </div>
                            <div className='col-md-6'>
                                {isEditEmployee && renderAppraisal()}
                            </div>
                        </div>
                    </div>
                </form>
            </>
        );
    };
    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"Manage Employee"}
                    breadCrumb={isAddEmployee ? "Add Employee" : isEditEmployee ? "Edit Employee" : ""}
                    isEditMode={isEditEmployee || isAddEmployee}
                    cancelEdit={cancelEdit} />
            </div>
            <div className='formDiv'>
                {isAddEmployee ? (
                    renderAddMode()
                ) : isEditEmployee ? (
                    renderEditMode()
                ) : (
                    <>
                        <div className='bxshadow p-2 borderRadius mb-4'>
                            {renderSearch()}
                        </div>
                        <div className='bxshadow p-2 borderRadius mb-4'>
                            {actionButtons()}
                        </div>
                        <div className='bxshadow p-2 borderRadius'>
                            {renderTable()}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default ManageEmployee;